import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './bus';
import './tools';
import 'jquery';
import 'bootstrap/dist/css/bootstrap.css';
import 'popper.js';
import 'bootstrap';
import '@/assets/js/lib/chart-js/Chart.bundle.js';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');

// router.beforeEach((to, from, next) => {
//   if (to.meta.requiresAuth) {
//     console.log('beforeEach');
//     next();
//   } else {
//     next();
//   }
// });